import { getActiveTheme } from './themeCache';
export var getComponentOverrides = function getComponentOverrides(componentName) {
  var activeTheme = getActiveTheme();
  if (!activeTheme || !activeTheme.componentOverrides) {
    return null;
  }
  return activeTheme.componentOverrides[componentName];
};